import { DistributionStatus } from '../../enums/distribution-status';
import { Cycle } from './cycle';
import { Device } from './device';
import { Distributor } from './distributor';
import { TotalWorkTime } from './total-work-time';
import { DistributionStreet } from './street';
import { DistributionAddress } from './distribution-address';

export class Distribution {
    public id: string;
    public noteId: string;
    public bdSectorId: string;
    public coachId: string;
    public cycle: Cycle;
    public addresses: DistributionAddress[];
    public devices: Device[];
    public distributor: Distributor;
    public lastProcessing?: Date;
    public percentageComplete: number;
    public percentageCompleteEarly: number;
    public percentageCompleteLate: number;
    public plannedStartDate: Date;
    public plannedEndDate: Date;
    public registeringComplete: Date;
    public registeringStarted: Date;
    public sectorId: string;
    public status: DistributionStatus;
    public streets: DistributionStreet[];
    public totalWorkTime: TotalWorkTime;

    constructor();
    constructor(json: any)
    constructor(json?: Distribution) {
        if (json) {
            Object.assign(this, json);
            this.cycle = new Cycle(json.cycle);
            this.distributor = new Distributor(json.distributor);
            this.plannedStartDate = json.plannedStartDate ? new Date(json.plannedStartDate) : null;
            this.plannedEndDate = json.plannedEndDate ? new Date(json.plannedEndDate) : null;
            this.lastProcessing = json.lastProcessing != null ? new Date(json.lastProcessing) : null;
            this.devices = json.devices.map((device: any) => new Device(device));
            this.addresses = json.addresses.map((address: any) => new DistributionAddress(address));
            this.streets = json.streets.map((street: any) => new DistributionStreet(street));
            this.totalWorkTime = json.totalWorkTime ? new TotalWorkTime(json.totalWorkTime) : null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/distribution/distribution.ts